import {
  TableSortLabel,
  Paper,
  Autocomplete,
  TextField,
  Alert,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import {
  getSelectedTimePeriod,
  roundStringNumberToInt,
} from "../../helpers/businessleaderDashboardHelpers";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import dayjs from "dayjs";
import {
  sitePerformanceAll,
  sitePerformancePerdformance,
  sitePerformanceIncome,
  sitePerformanceUserBehavior,
} from "./AdditionalQueriesConstants";
import store from "../../../../../../store";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../../features/userSlice";
import { buiDashboardEndPointLogic } from "../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboard/buiDashboardEndPointLogic";
import { useSelector } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";

export const SitePerformance = React.memo(() => {
  const authToken = useSelector(selectUserToken)?.toString();

  const {
    selectedSharedUidBui,
    selectedDimensions,
    selectedType,
    selectedAll,
  } = useSelector((state: any) => state?.businessLeaderDashBoard);

  const [sitePerformanceSectionData, setsitePerformanceSectionData] = useState(
    []
  ) as any;

  const [rows, setRows] = useState([]);
  const tableHeadingsAll = sitePerformanceAll;

  // for alert message
  const datesForFirstTimeLoading = getSelectedTimePeriod("Last 30 Days"); // for first time loading
  const [savedStartDate, setSavedStartDate] = useState(
    datesForFirstTimeLoading.startDate
  ) as any;
  const [savedEndDate, setSavedEndDate] = useState(
    datesForFirstTimeLoading.endDate
  ) as any;

  const [selectedTimeFrame, setSelectedTimeFrame] = useState({
    label: "Last 30 Days",
    queryId: "5685839489138688",
  }) as any;

  const [order, setOrder] = useState("desc") as any;
  const [orderBy, setOrderBy] = useState("date") as any;

  const [visibleColumns, setVisibleColumns] = useState(tableHeadingsAll);

  const [selectedValue, setSelectedValue] = useState("All"); // Default selection

  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
  };

  const timeFrame = [
    { label: "Last 30 Days", queryId: "5685839489138688" },
    { label: "Last 6 Week", queryId: "5649205632696320" },
    { label: "Last 12 Month Full", queryId: "5650452045627392" },
    { label: "Last 12 Month Proportional", queryId: "5650452045627392" },
  ];

  const getSitePerformanceData = (
    queryId?: string,
    startDate?: string,
    endDate?: string,
    period?: string
  ) => {
    try {
      let currentStartDate = savedStartDate;
      let currentEndDate = savedEndDate;
      let currentQueryId = selectedTimeFrame?.queryId;
      if (startDate && endDate && queryId) {
        currentStartDate = startDate;
        currentEndDate = endDate;
        currentQueryId = queryId;
      }
      if (period) {
        buiDashboardEndPointLogic.getBuiDashboardData_sitePerformance(
          authToken as string,
          selectedSharedUidBui,
          currentQueryId,
          trackPromise,
          setsitePerformanceSectionData,
          selectedDimensions,
          selectedType,
          selectedAll,
          currentStartDate,
          currentEndDate,
          period
        );
      } else {
        buiDashboardEndPointLogic.getBuiDashboardData_sitePerformance(
          authToken as string,
          selectedSharedUidBui,
          currentQueryId,
          trackPromise,
          setsitePerformanceSectionData,
          selectedDimensions,
          selectedType,
          selectedAll,
          currentStartDate,
          currentEndDate
        );
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    }
  };

  useEffect(() => {
    getSitePerformanceData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (sitePerformanceSectionData?.query_output?.length > 0) {
      setRows(sitePerformanceSectionData?.query_output);
    } else {
      setRows([]);
    }
    // eslint-disable-next-line
  }, [sitePerformanceSectionData]);

  const parseValue = (value: any) => {
    if (typeof value === "string") {
      if (value.includes("%")) {
        return parseFloat(value.replace("%", ""));
      }
      if (value.includes("$")) {
        return parseFloat(value.replace("$", ""));
      } else {
        return value.toLowerCase();
      }
    } else if (value === null || !value) {
      return "";
    }
    return value;
  };

  const handleRequestSort = (property: any) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedRows = [...rows].sort((a, b) => {
    const aValue = parseValue(a[orderBy]);
    const bValue = parseValue(b[orderBy]);

    if (aValue < bValue) {
      return order === "asc" ? -1 : 1;
    }
    if (aValue > bValue) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });

  const handleTimeFrameChange = (_: unknown, value: any) => {
    setSelectedTimeFrame(value?.label);
    const dates = getSelectedTimePeriod(value?.label);
    if ((dates.endDate && dates.startDate) || dates?.periodType) {
      setSavedStartDate(dates.startDate);
      setSavedEndDate(dates.endDate);
      if (dates.periodType === "Full") {
        setSavedStartDate(
          dayjs().subtract(1, "year").startOf("year").format("YYYY-MM-DD")
        );
        setSavedEndDate(dayjs().format("YYYY-MM-DD"));
        dates.startDate = dayjs()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD");
        dates.endDate = dayjs().format("YYYY-MM-DD");
      }
      if (dates.periodType === "Proportional") {
        const today = dayjs();
        setSavedStartDate(
          dayjs().subtract(1, "year").startOf("year").format("YYYY-MM-DD")
        );
        setSavedEndDate(dayjs(today).subtract(1, "day").format("YYYY-MM-DD"));
        dates.startDate = dayjs()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD");
        dates.endDate = dayjs(today).subtract(1, "day").format("YYYY-MM-DD");
      }
      getSitePerformanceData(
        value?.queryId,
        dates.startDate as string,
        dates.endDate as string,
        dates.periodType
      );
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "No Dates Choosen",
          type: "error",
        })
      );
    }
  };

  // Handle radio button changes
  const handleRadioChange = (event: any) => {
    const selectedValue = event.target.value;

    // Set visible columns based on radio button value
    switch (selectedValue) {
      case "User Behavior":
        setVisibleColumns(sitePerformanceUserBehavior); // Show User Behavior
        break;
      case "Income":
        setVisibleColumns(sitePerformanceIncome); // Show Income
        break;
      case "Performance":
        setVisibleColumns(sitePerformancePerdformance); // Show Performance
        break;
      case "All":
        setVisibleColumns(tableHeadingsAll); // Show All
        break;
      default:
        setVisibleColumns(sitePerformanceUserBehavior); // Default to no columns
    }
  };

  const getRow = (col: any, row: any) => {
    if (row[col?.key] === null) {
      return "null";
    } else if (col?.key === "date") {
      if (row?.date) {
        return `${row?.day} ${dayjs(row?.date).format("DD-MM-YYYY")}`;
      } else if (row?.month) {
        return row?.month;
      } else if (row?.start_of_week) {
        return row?.start_of_week;
      }
    } else if (
      col?.label === "CVR%" ||
      col?.label === "% RS From Total Income" ||
      col?.key === "roi_perc" ||
      col?.key === "ng_ftd_br_ftd"
    ) {
      return roundStringNumberToInt(row[col?.key] * 100) + "%";
    } else if (
      row[col?.key] !== 0 &&
      col?.key !== "date" &&
      col?.key !== "br_ftd" &&
      col?.key !== "ng_ftd" &&
      col?.key !== "qftds" &&
      col?.key !== "qftds" &&
      col?.key !== "click_in" &&
      col?.key !== "click_out" &&
      col?.key !== "ftd_incent"
    ) {
      return roundStringNumberToInt(row[col?.key]) + "$";
    } else {
      return row[col?.key];
    }
  };

  const getDateColumn = (col: any) => {
    if (col?.key === "date") {
      if (selectedTimeFrame === "Last 30 Days") {
        return `Day`;
      } else if (
        selectedTimeFrame === "Last 12 Month Full" ||
        selectedTimeFrame === "Last 12 Month Proportional"
      ) {
        return "Month";
      } else if (selectedTimeFrame === "Last 6 Week") {
        return "Week";
      }
    }
    return col?.label;
  };

  const getRowCSV = (col: any, row: any) => {
    if (row[col?.key] === null) {
      return "null";
    } else if (col?.key === "date") {
      if (row?.date) {
        return `${row?.day} ${dayjs(row?.date).format("DD-MM-YYYY")}`;
      } else if (row?.month) {
        return row?.month;
      } else if (row?.start_of_week) {
        return row?.start_of_week;
      }
    } else if (
      col?.label === "CVR%" ||
      col?.label === "% RS From Total Income" ||
      col?.key === "roi_perc" ||
      col?.key === "ng_ftd_br_ftd"
    ) {
      let value = row[col?.key] * 100;
      value = Math.round(value);
      return value + "%";
    } else if (
      row[col?.key] !== 0 &&
      col?.key !== "date" &&
      col?.key !== "br_ftd" &&
      col?.key !== "ng_ftd" &&
      col?.key !== "qftds" &&
      col?.key !== "qftds" &&
      col?.key !== "click_in" &&
      col?.key !== "click_out"
    ) {
      let value = Math.round(row[col?.key]);
      return value + "$";
    } else {
      return row[col?.key];
    }
  };

  const handleExportCSV = () => {
    const csvRows = [];

    // Extract the table headers
    const headers = tableHeadingsAll.map((pair) => pair.key) as any;
    csvRows.push(headers.join(","));

    // Extract the table data
    // eslint-disable-next-line
    sortedRows.map((row: any) => {
      let rowData = [] as any;
      // eslint-disable-next-line
      tableHeadingsAll.map((key: any) => {
        const result = getRowCSV(key, row);
        if (result !== "null") {
          rowData.push(result);
        }
      });
      if (rowData?.length > 0) {
        csvRows.push(rowData.join(","));
      }
    });

    // Convert CSV rows to a single string
    const csvString = csvRows.join("\n");

    // Create a blob and download the file
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "SitePerformance.csv");
  };

  return (
    <>
      <Grid alignItems={"center"} container px={2} columnSpacing={2}>
        <Grid size={12}>
          <Stack flexDirection={"row"} alignItems="center" gap={2}>
            <Alert
              sx={{
                color: "#ED6C02",
                margin: "16px",
                border: "1px solid #ED6C0280",
                width: "100%",
              }}
              severity="warning"
              icon={<InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />}
            >
              PLEASE NOTE: Data is only relevant for the period of{" "}
              {dayjs(savedStartDate).format("DD-MM-YYYY")} -{" "}
              {dayjs(savedEndDate).format("DD-MM-YYYY")}
            </Alert>
            <IconButton color="secondary" size="large" data-tracker="281">
              <DownloadIcon fontSize="medium" onClick={handleExportCSV} />
            </IconButton>
          </Stack>
        </Grid>
        <Grid size={9} px={2}>
          <FormControl>
            <FormLabel
              color="secondary"
              id="demo-row-radio-buttons-group-label"
            >
              Data set:
            </FormLabel>
            <RadioGroup
              value={selectedValue}
              onChange={handleChange}
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="User Behavior"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    defaultChecked
                    inputProps={
                      { "data-tracker": "283" } as Record<string, any>
                    }
                  />
                }
                label="User Behavior"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="Income"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "290" } as Record<string, any>
                    }
                  />
                }
                label="Income"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="Performance"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "291" } as Record<string, any>
                    }
                  />
                }
                label="Performance"
                onChange={handleRadioChange}
              />
              <FormControlLabel
                value="All"
                control={
                  <Radio
                    color="secondary"
                    size="small"
                    inputProps={
                      { "data-tracker": "292" } as Record<string, any>
                    }
                  />
                }
                label="All"
                onChange={handleRadioChange}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid size={3}>
          <Autocomplete
            data-tracker="90"
            sx={{ width: "100%" }}
            onChange={handleTimeFrameChange}
            options={timeFrame}
            value={selectedTimeFrame}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select Time Frame"
                label="Time Frame"
                color="secondary"
              />
            )}
            size="small"
          />
        </Grid>
      </Grid>

      <TableContainer
        className="RunRateTableWrap"
        component={Paper}
        sx={{ boxShadow: "none", maxHeight: 400, overflowY: "auto" }}
      >
        {rows?.length > 0 ? (
          <>
            <Table aria-label="collapsible table" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  {tableHeadingsAll
                    ?.filter((col: any) =>
                      visibleColumns?.some(
                        (item: any) => item["key"] === col?.key
                      )
                    )
                    ?.map((col: any) => (
                      <TableCell
                        key={col?.key + "tabellCellSite" + Math.random()}
                        align="left"
                      >
                        <TableSortLabel
                          active={orderBy === col?.key}
                          direction={orderBy === col?.key ? order : "asc"}
                          onClick={() => handleRequestSort(col?.key)}
                        >
                          {getDateColumn(col)}
                        </TableSortLabel>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedRows?.map((row: any, rowIndex: any) => (
                  <React.Fragment key={rowIndex + "sortedSite" + Math.random()}>
                    <TableRow
                      sx={{
                        "&:not(:last-child) > *": {
                          borderBottom:
                            "1px solid rgba(224, 224, 224, 1) !important",
                        },
                      }}
                    >
                      {tableHeadingsAll
                        ?.filter((col: any) =>
                          visibleColumns?.some(
                            (item: any) => item["key"] === col?.key
                          )
                        )
                        ?.map((col: any) => (
                          <TableCell
                            key={col?.key + "cellSorted" + Math.random()}
                            align="left"
                          >
                            {getRow(col, row)}
                          </TableCell>
                        ))}
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </>
        ) : (
          <Alert
            sx={{
              color: "#ED6C02",
              margin: "16px",
              border: "1px solid #ED6C0280",
            }}
            severity="warning"
            icon={<InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />}
          >
            NO DATA
          </Alert>
        )}
      </TableContainer>
    </>
  );
});
